export default function ($filter, timetableService, plannerFactory, $uibModal) {

    var selectionModalTemplate = `
        <div class="modal-header">
           <h3 class="mb-0 h4" id="update-modal-label">Update selection:<br />
           {{ ::courseCode }} {{ ::courseName }}</h3>
        </div>
        <div class="modal-body">
           <study-load classes="classTypes" ng-if="validClasses"></study-load>
            <div class="alert mb-3" ng-if="hasMultiday === true">
                <i class="fal fa-comment-alt-exclamation"></i>
                <div>
                   <p >This class has multiple offerings each week, or an irregular schedule. Modifying it will update multiple class times in the planner.</p>
                </div>    
            </div>
           <form role="form" class="update-selection-form">
               <div class="form-row" ng-class="{\'no-active-classes\': validClasses.length === 0}">
                   <label for="add-class" class="col-form-label col-sm-4">Add class</label>
                   <div class="col">
                       <select name="add-class" ng-if="validClasses" ng-model="toAdd" class="form-control"
                           ng-options="(c.classNo.toString()+c.classMeetingNo.toString()) as getNgOption(c) for c in validClasses" ng-change="SetSelectedClass(toAdd)">
                           <option value="">Select a class</option>
                       </select>
                       <p ng-if="!validClasses">No classes available</p>
                   </div>
               </div>
               <span class="or d-flex justify-content-center align-items-center" ng-show="showCurrent"> OR </span>
               <div class="form-row" ng-show="showCurrent">
                   <label for="remove-class" class="col-form-label col-sm-4">Remove class</label>
                   <div class="col">
                        <div class="custom-control custom-checkbox" ng-repeat="c in current track by $index">
                            <input type="checkbox" id="option_{{$index}}" 
                                value="" ng-model="c.checked" ng-change="markForRemoval()"
                                class="custom-control-input" name="remove-class" />
                            <label class="custom-control-label" for="option_{{$index}}" ng-bind="getNgOption(c)"></label>
                        </div>                    
                   </div>
               </div>
           </form>
        </div>
        <div class="modal-footer">
           <button class="btn btn-outline-primary" ng-click="cancel()">Cancel</button>
           <button class="btn btn-primary" ng-click="ok()">OK</button>
        </div>`;

    return {
        scope: {
            course: '='
        },
        restrict: 'EA',
        replace: true,
        template: `
            <li class="course-card">
              <a ng-click="updateSelectionModal()" class="course-card-link" title="Update selections for {{ course.courseCode }}" stop-event>
                <h5 class="course-card-title" ng-bind="course.courseCode"></h5>
                <span class="course-card-name" ng-bind="course.description"></span>
                <button class="btn btn-link course-card-btn">
                    <i class="fal fa-xmark" title="Remove from planner" ng-click="removeFromPlanner()" stop-event></i>
                </button>                
              </a>
            </li>`,
        link: function (scope) {

            scope.removeFromPlanner = function () {
                plannerFactory.removeFromPlanner(scope.course, true);
            }

            scope.updateSelectionModal = function () {
                var classes = [],
                    current = [],
                    selectedClassIds = plannerFactory.getSelectedClassIds(),
                    i, k, l;

                timetableService.getClasses(scope.course.courseId).then(function (resp) {

                    var r = resp.data ? resp.data.data : resp;

                    for (i = 0, l = r.length; i < l; i++) {
                        k = r[i];

                        if (k.meetingStartTime !== null) {
                            k.meetingStartTime = $filter('date')(k.meetingStartTime, 'HH:MM');
                            k.meetingEndTime = $filter('date')(k.meetingEndTime, 'HH:MM');
                            k.courseCode = scope.course.courseCode;
                            k.description = scope.course.courseName;
                            k.termId = scope.course.termId;
                            k.courseId = scope.course.courseId;
                            k.checked = false;

                            if (k.classMeetingNo && selectedClassIds.indexOf(k.classNo.toString() + k.classMeetingNo.toString()) === -1) {
                                classes.push(k);
                            } else if (k.hasOwnProperty('classNo')) {
                                current.push(k);
                            }
                        }
                    }

                    var modalInstance = $uibModal.open({
                        template: selectionModalTemplate,
                        controller: 'UpdateClassSelectionModalCtrl',
                        resolve: {
                            courseCode: () => scope.course.courseCode,
                            courseName: () => scope.course.description,
                            current: () => current,
                            classes: () => classes
                        }
                    });

                    modalInstance.result.then(function (resp) {

                        // class to be added to planner
                        if (resp[0].length > 0) {
                            var classToAdd = resp[0][0],
                                classesToAdd = classes.where(function (c) {
                                    // need to return any classes with the same id, to allow for multi-day classes
                                    return c.classNo === classToAdd.classNo;
                                });

                            plannerFactory.addToPlanner(classesToAdd,
                                classToAdd.courseCode,
                                classToAdd.description,
                                classToAdd.courseId,
                                classToAdd.termId,
                                true);
                        }

                        // classes to be removed from planner
                        if (resp[1].length > 0) {
                            for (i = 0, l = resp[1].length; i < l; i++) {
                                plannerFactory.removeFromPlanner(resp[1][i], false);
                            }
                        }
                    }, () => {});
                });
            };
        }
    };
};